export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string | null | undefined): boolean => {
  if (!value) return false;
  return emailRegex.test(value);
};

export const validateEmail = (value: string | null | undefined): string | null => {
  return isValidEmail(value) ? null : "Please enter a valid email address";
};
